import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import {postData} from "../../utils/request";
import Button from "../form/Button";
import BoxEditor from "./BoxEditor";
import ShippingTourList from "./lists/TourList";
import ShippingTourForm from "./forms/TourForm";
import {showModal} from "../../actions";
import {connect} from "react-redux";

class TourEditor extends React.Component {

    state = {
        groupagesToTourSelection: []
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }
    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const newbutton = <Button
        type="button"
        disabled={this.props.isLoading}
        color="default"
        className="pull-left"
        onClick={this.pristineForm}
    >
        Új
    </Button>;
    const actions = <Fragment>
        <Button
            disabled={!this.props.dirty || this.props.isLoading}
            color="primary"
            className="pull-right"
            onClick={this.saveForm}
        >
            Mentés
        </Button>
        <Button
            disabled={!this.props.values[this.props.componentConfig.idfield] || !this.props.values?.partner?.partner_id || this.props.isLoading}
            color="danger"
            onClick={this.props.deleteForm}
        >
            Törlés
        </Button>
    </Fragment>;
        
        return (
            <Fragment>
                <List 
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Túra lista"}
                    footer={newbutton}
                >
                    <ShippingTourList {...this.props} />
                </List>

                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Túra adatai"}
					footer={actions}
                >
                    <ShippingTourForm {...this.props}
                    />
                    
                </Editor>
            </Fragment>
        );
    }
}

export default connect(() => ({}), {showModal})(createEditor({
    componentName: "Tour", 
    WrappedComponent: TourEditor
}));